/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Assignees from './Assignees/index'
import Comments from './Comments/index'
import CreatedDate from './CreatedDate/index'
import DueDate from './DueDate/index'
import Patient from './Patient/index'
import PatientActions from './PatientActions/index'
import Priority from './Priority/index'
import React from 'react'
import Tags from './Tags/index'
import TaskDoneAction from './TaskDoneAction/index'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Card({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card",
  onMouseEnter,
  onMouseLeave,
  onMouseUp,
  hovered,
  dragging,
  moved
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let cardPatientValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient',
})
  return (<React.Fragment
>
<div
  data-testid="Card.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onMouseUp={onMouseUp}
 style={{'--pt-2-9dqY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-9dqY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-9dqY': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-5-9dqY': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bblr-7-9dqY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-8-9dqY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-9-9dqY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-10-9dqY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-11-9dqY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-12-9dqY': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bc-1-9dqY': hovered ? dtColorsNeutral200 : moved ? dtColorsNeutral200 : dtColorsWhite,'--ss-13-9dqY': dragging ? "1px" : "0px",'--bc-6-9dqY': moved ? dtColorsNeutral300 : dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Card.Horizontal"
  data-view-path={viewPath}
 style={{'--g-11-9dqY': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<Priority
  viewPath={`${viewPath}/Priority`}
/>
<CreatedDate
  viewPath={`${viewPath}/CreatedDate`}
/>
<Comments
  viewPath={`${viewPath}/Comments`}
/>
</div>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
<Title
  viewPath={`${viewPath}/Title`}
/>
<div
  data-testid="Card.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Assignees
  viewPath={`${viewPath}/Assignees`}
/>
<DueDate
  viewPath={`${viewPath}/DueDate`}
/>
</div>
<div
  data-testid="Card.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mh-14-9dqY': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal2}`}
>
<fromFlow.When is={!hovered}>
<Tags
  viewPath={`${viewPath}/Tags`}
 data="card.patient"
/>
</fromFlow.When>
<div
  data-testid="Card.Horizontal:3"
  data-view-path={viewPath}
 style={{'--d-15-9dqY': hovered ? "flex" : "none"}}
 className={`views-block ${styles.Horizontal3}`}
>
<fromFlow.When is={cardPatientValueData}>
<PatientActions
  viewPath={`${viewPath}/PatientActions`}
 data="card.patient"
/>
</fromFlow.When>
</div>
<fromFlow.When is={hovered}>
<TaskDoneAction
  viewPath={`${viewPath}/TaskDoneAction`}
/>
</fromFlow.When>
</div>
</div>
{children}
</React.Fragment>)
}